import { useState, useEffect } from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';

const CustomerReviewsSection = () => {
  const reviews = [
    {
      id: 1,
      name: "Prasanna R",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "After a long search... we have finally found our dream home... The builder Mr. Karthik Reddy is very much kind and supportive... pretty good in quality construction... and are trustworthy!",
      unit: "Flat No 821",
      avatar: null,
      verified: true
    },
    {
      id: 2,
      name: "Gopinath N",
      location: "Bank Manager IOB",
      rating: 5,
      review: "Mr. Karthik Reddy is proving Residential Flats without compromising on quality at an affordable price... Most of his Constructions are being undertaken near Good Schools. That is one more advantage other than affordable price.",
      unit: "Bank Professional",
      avatar: null,
      verified: true
    },
    {
      id: 3,
      name: "Sriram",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "Blucon Sunshine - We feel very fortunate about finding this project. Location... is very near to main road and you can easily access shops, hospitals etc. Mr. Karthik Reddy(Builder) is very friendly and anyone can easily approach him directly",
      unit: "Flat No 731",
      avatar: null,
      verified: true
    },
    {
      id: 4,
      name: "Babu Seetharaman",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "The first impression of the site made us very satisfied and Mr.karthik reddy the owner was very kind and humble... and Miss. Meenakshi reddy the interior designer was very sweet and humble and made our house soo aesthetic",
      unit: "Flat No 831",
      avatar: null,
      verified: true
    },
    {
      id: 5,
      name: "Sundhar Kumaar",
      location: "Multiple Flat Owner",
      rating: 5,
      review: "The Most Courteous and friendly nature. They made our Purchase of Dream House for my 2 Daughters Very Simple and in a Effortless Process. We are Proud to have Associated with this Blucon Sunshine Project.",
      unit: "Multiple Units",
      avatar: null,
      verified: true
    },
    {
      id: 6,
      name: "Koushik Hariharan",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "Very nice construction company .Mr. Karthik Reddy sir Very easy to get along with. This place has all the facilities. May Bhagwan Sri Senthil Nathan bless his work.",
      unit: "Flat No 612",
      avatar: null,
      verified: true
    },
    {
      id: 7,
      name: "Balakrishna Bhat",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "It's great, I really like it. The bindings are amazing. Everyone please support me well. Good builder...Karthik Builder",
      unit: "Flat No 632",
      avatar: null,
      verified: true
    },
    {
      id: 8,
      name: "Valanarasu",
      location: "Multiple Flat Owner",
      rating: 5,
      review: "Blucon Pristine wonderful community... Landmark is near to hospitals, schools and easy access from porur junction. Builder Mr.Karthik I love the way he handles each and every customer and their custom needs for their dream home.",
      unit: "Multiple Units",
      avatar: null,
      verified: true
    },
    {
      id: 9,
      name: "Manoj Yadav",
      location: "Blucon Pristine Resident",
      rating: 5,
      review: "I feel so amazed to be part of the Blucon pristine community… Good environment, Good construction , Delivered the flat on time... especially the quality of the construction is beautiful.",
      unit: "Flat No C4 S2",
      avatar: null,
      verified: true
    },
    {
      id: 10,
      name: "Sridhar Swaminathan",
      location: "Blucon Pristine Resident",
      rating: 5,
      review: "Wonderful place and easy access from porur junction, very friendly and responsive builder, I highly recommend bluecon superstructure's projects to my friends and family members",
      unit: "Flat No B2 S1",
      avatar: null,
      verified: true
    },
    {
      id: 11,
      name: "Prabhu J",
      location: "Blueoak Elite Resident",
      rating: 5,
      review: "When I was looking for the sites near Kolapakkam... I found this site n the cost was affordable. The builder named Karthik was genuine to me n he was transparent. At last I was able to be in the ideal home which I was looking forward..",
      unit: "Flat A2 S2",
      avatar: null,
      verified: true
    },
    {
      id: 12,
      name: "Sajiv Sreedhar",
      location: "Blueoak Elite Resident",
      rating: 5,
      review: "Being my 1st property... I am so thankfull to Mr.Karthi (The builder) who shown us this site... I was able to give him my changes and he had updated all that i wanted without any objection.",
      unit: "Flat A4 S1",
      avatar: null,
      verified: true
    },
    {
      id: 13,
      name: "Sasee Kumar",
      location: "Blueoak Elite Resident",
      rating: 5,
      review: "I bought this flat is too low price in our market rate, and it's fine and good quality when compared on other flats, and the property is worth. The proprietor karthik also nice coordinator, it's good...",
      unit: "Flat A1 S1",
      avatar: null,
      verified: true
    },
    {
      id: 14,
      name: "Naveen Nandha",
      location: "Blueoak Elite Resident",
      rating: 5,
      review: "Me and my wife search for the apartment nearly 50 and above in that Blue Oak Elite is the best in price scheme and quality and builder name is Mr.katthick which he is very good in resolving over problem and good support...",
      unit: "Flat A2 F1",
      avatar: null,
      verified: true
    },
    {
      id: 15,
      name: "Sreedhar Rao D R",
      location: "Blue Oak Elite Resident",
      rating: 5,
      review: "Reliable Builder.Reasonably Priced Maintains good Relationship with Customers and Obliged Builder 👌👏🙏💐",
      unit: "Flat A1 F1",
      avatar: null,
      verified: true
    },
    {
      id: 16,
      name: "Swathi K",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "'Blucon sunshine' is located in the fastest developing area and having a easy accessibility... Mr. Karthik Reddy (Owner) is very accountable and supportive. Construction is going on a faster phase. Good place to get located in Chennai.",
      unit: "Flat No 611",
      avatar: null,
      verified: true
    },
    {
      id: 17,
      name: "Vidhya S",
      location: "Blucon Sunshine Resident",
      rating: 5,
      review: "We bought a flat in Blucon Sunshine and we are very satisfied and happy. Mr Karthik is very humble and kind person, he made the entire process very easy and we are very thankful for that. The quality of the building is really good",
      unit: "Flat No 732",
      avatar: null,
      verified: true
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const reviewsPerPage = 3;
  const totalSlides = Math.ceil(reviews.length / reviewsPerPage);
  const autoSlideInterval = 5000; // 5 seconds

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };


  // Auto-slide functionality
  useEffect(() => {
    if (!isHovered) {
      const interval = setInterval(() => {
        nextSlide();
      }, autoSlideInterval);
      
      return () => clearInterval(interval);
    }
  }, [currentSlide, isHovered, totalSlides]);

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={index}
        className={`w-4 h-4 ${
          index < rating 
            ? 'fill-amber-400 text-amber-400' 
            : 'text-gray-300'
        }`}
      />
    ));
  };

  const averageRating = reviews.reduce((sum, review) => sum + review.rating, 0) / reviews.length;
  const totalReviews = reviews.length;

  return (
    <section id="reviews" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <Badge variant="secondary" className="mb-4 bg-amber-100 text-teal-700">
            Customer Reviews
          </Badge>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Residents Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Hear from our happy residents about their experience living at Blucon Projects. 
            Their testimonials speak to our commitment to quality and excellence.
          </p>
          
          {/* Overall Rating Summary */}
          <div className="flex items-center justify-center gap-6 mb-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-700 mb-1">
                {averageRating.toFixed(1)}
              </div>
              <div className="flex items-center justify-center mb-2">
                {renderStars(Math.round(averageRating))}
              </div>
              <div className="text-sm text-gray-600">
                Based on {totalReviews} reviews
              </div>
            </div>
            <div className="w-px h-16 bg-gray-300"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-amber-600 mb-1">
                100%
              </div>
              <div className="text-sm text-gray-600">
                Verified<br />Residents
              </div>
            </div>
          </div>
        </div>

        {/* Reviews Carousel */}
        <div 
          className="relative"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors duration-200 border border-gray-200"
            aria-label="Previous reviews"
          >
            <ChevronLeft className="w-6 h-6 text-gray-600" />
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white shadow-lg rounded-full flex items-center justify-center hover:bg-gray-50 transition-colors duration-200 border border-gray-200"
            aria-label="Next reviews"
          >
            <ChevronRight className="w-6 h-6 text-gray-600" />
          </button>

          {/* Reviews Grid */}
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div key={slideIndex} className="w-full flex-shrink-0">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
                    {reviews
                      .slice(slideIndex * reviewsPerPage, (slideIndex + 1) * reviewsPerPage)
                      .map((review) => (
                        <Card 
                          key={review.id} 
                          className="border-0 shadow-lg shadow-amber-100/20 hover:shadow-xl hover:shadow-amber-100/30 transition-all duration-300 group"
                        >
                          <CardContent className="p-6">
                            {/* Quote Icon */}
                            <div className="flex justify-between items-start mb-4">
                              <Quote className="w-8 h-8 text-amber-400 group-hover:text-amber-500 transition-colors duration-200" />
                              {review.verified && (
                                <Badge variant="outline" className="border-green-200 text-green-700 text-xs">
                                  Verified Resident
                                </Badge>
                              )}
                            </div>

                            {/* Rating */}
                            <div className="flex items-center gap-1 mb-4">
                              {renderStars(review.rating)}
                            </div>

                            {/* Review Text */}
                            <p className="text-gray-700 mb-6 leading-relaxed">
                              "{review.review}"
                            </p>

                            {/* Customer Info */}
                            <div className="flex items-start justify-between">
                              <div className="flex items-center gap-3">
                                <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center">
                                  <span className="text-white font-semibold text-lg">
                                    {review.name.split(' ').map(n => n[0]).join('')}
                                  </span>
                                </div>
                                <div>
                                  <div className="font-semibold text-gray-900">
                                    {review.name}
                                  </div>
                                  <div className="text-sm text-gray-600">
                                    {review.location}
                                  </div>
                                </div>
                              </div>
                              <div className="text-right">
                                <Badge variant="secondary" className="bg-amber-50 text-teal-700 text-xs">
                                  {review.unit}
                                </Badge>
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center mt-8 space-x-2">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition-all duration-200 ${
                index === currentSlide
                  ? 'bg-teal-600 scale-110'
                  : 'bg-gray-300 hover:bg-gray-400'
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Auto-slide Indicator */}
        <div className="flex justify-center items-center mt-4 text-sm text-gray-500">
          <span className="flex items-center gap-2">
            <div className={`w-2 h-2 rounded-full ${isHovered ? 'bg-amber-400' : 'bg-teal-400'} animate-pulse`}></div>
            {isHovered ? 'Auto-slide paused' : 'Auto-sliding every 5 seconds'}
          </span>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 bg-white rounded-2xl p-8 shadow-lg shadow-amber-100/20">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-green-700 mb-2">200+</div>
              <div className="text-gray-600">Happy Families</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-700 mb-2">98%</div>
              <div className="text-gray-600">Satisfaction Rate</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-700 mb-2">4.8/5</div>
              <div className="text-gray-600">Average Rating</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-green-700 mb-2">100%</div>
              <div className="text-gray-600">On-Time Delivery</div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            Join our community of satisfied residents
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#contact" 
              className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-teal-600 to-teal-700 hover:from-teal-700 hover:to-teal-800 text-white rounded-lg transition-all duration-200 hover:scale-105"
            >
              Schedule a Visit
            </a>
            <a 
              href="#floor-plans" 
              className="inline-flex items-center justify-center px-6 py-3 border border-amber-300 text-teal-700 hover:bg-amber-50 rounded-lg transition-all duration-200 hover:scale-105"
            >
              View Floor Plans
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomerReviewsSection;